/*global _, $ */
import {Vue} from '~/addiesaas'
import {formatDate, DateTime} from 'utils/vue/lib/dates'
import V from 'utils/vue/lib/validations'

const MOUNTED = 're-profile-support.mounted'
const HIDE_FIELDS = ['subject']
const AUTO_GENERATE_SUBJECT = true
const AUTO_GENERATE_SUBJECT_ON_CHANGE = ['first_name', 'contact_name', 'description']

export default (Bus) => {
  Bus.$on(MOUNTED, async (vm) => {
    await vm.$nextTick()
    const container = $(vm.$el).find('.re-embed-content')
    const options = getOptions(vm)
    setupForm(container, vm, options)
  })
}

const getOptions = (vm) => {
  const hideFields = vm.$$s('form.hideFields', HIDE_FIELDS)
  const autoGenerateSubject = vm.$$s('form.autoGenerateSubject', AUTO_GENERATE_SUBJECT)
  const autoGenerateSubjectOnChange = vm.$$s('form.autoGenerateSubjectOnChange', AUTO_GENERATE_SUBJECT_ON_CHANGE)

  return {
    ...vm.$$s('form', {}),
    hideFields,
    autoGenerateSubject,
    autoGenerateSubjectOnChange
  }
}

const setupForm = (container, vm, options) => {
  const allFields = parseFields(container, vm, options)
  const fields = _.mapValues(allFields, 'value')

  const proxy = new Vue({
    data: {
      validationEnabled: false,
      fields,
      form: {
        fields: allFields
      },
      validations: _.mapValues(allFields, ({name, messages: items}) => ({name, items}))
    },
    validations() {
      return {
        fields: this.validationEnabled ? _.mapValues(allFields, 'rules') : {}
      }
    },
    computed: {},
    watch: {
      '$v.$invalid'(isInvalid) {
        this.enableDisableSubmit(!isInvalid)
      },
      ...(_.mapValues(_.mapKeys(allFields, f => `fields.${f.name}`), field => {
        return function (value) {
          if (options.autoGenerateSubject) {
            // always auto generate subject if manually set to blank
            const isSubjectBlank = field.name === 'subject' && !value
            if (isSubjectBlank || options.autoGenerateSubjectOnChange.includes(field.name)) {
              this.updateAutoSubject(field)
            }
          }
          this.showHideFieldError(field)
        }
      }))
    },
    created() {
      const fields = this.form.fields
      _.forOwn(fields, field => {
        const {el, name} = field
        el.on('change input', (e) => {
          this.fields[name] = e.target.value
          this.$v.$touch()
        })
      })
    },
    methods: {
      getAutoSubject() {
        if (!options.autoGenerateSubject) {
          return ''
        }
        const {first_name = '', contact_name = '', email = '', description = ''} = this.fields
        let defaultSubject = 'New issue'
        if (first_name){
          defaultSubject += ` from ${first_name} ${contact_name}`
        }
        if (email){
          defaultSubject += ` <${email}>`
        }
        return description ? description.replace(/[\r\n\t]/g, '').substring(0, 50) : defaultSubject
      },
      updateAutoSubject() {
        if (options.autoGenerateSubject) {
          const subjectField = this.form.fields['subject']
          if (subjectField) {
            const subject = this.getAutoSubject()
            subjectField.el.val(subject)
            this.fields.subject = subject
          }
        }
      },
      enableDisableSubmit(enabled) {
        container.find('input[type=submit]').prop('disabled', !enabled)
      },
      showHideFieldError({name, kebabName}) {
        const v = this.$v.fields[name]
        const items = (this.validations[name] || {}).items
        if (items) {
          const errors = _.mapValues(items, i => i.error)
          const messages = _.filter(_.mapValues(errors, (message, key) => {
            return v[key] ? false : message
          }))
          const html = (_.values(messages || {})).map(m => `<div>${m}</div>`).join('')
          const errorContainer = container.find(`.error.error-${kebabName}`)
          errorContainer.html(html)
          if (html) {
            errorContainer.removeClass('hidden')
          } else {
            errorContainer.addClass('hidden')
          }
        }
      }
    }
  })
  vm.data.getForm = () => proxy
  moveHints(container, vm)
  overrideReset(container, vm, proxy)
  overrideValidation(container, vm, proxy)
  hydrate(container, vm, proxy, options)

  return proxy
}

const hydrate = (container, vm, proxy, options) => {
  // add first name, last name, email and date
  const user = vm.user
  if (user) {
    proxy.validationEnabled = false
    proxy.$v.$reset()
    proxy.fields.first_name = user.first_name
    proxy.fields.last_name = user.last_name
    proxy.fields.contact_name = user.last_name
    proxy.fields.email = user.email
    container.find('tr.field-first-name input').val(user.first_name)
    container.find('tr.field-last-name input').val(user.last_name)
    container.find('tr.field-contact-name input').val(user.last_name)
    container.find('tr.field-email input').val(user.email)

    const date = formatDate('now', 'MM/dd/yyyy')
    container.find('tr.field-date-and-approximate-time input').val(date)
    container.find('tr.field-date-time input').val(date)

    if (options.autoGenerateSubject) {
      container.find('tr.field-subject input').val(proxy.getAutoSubject())
    }

    proxy.fields.date_and_approximate_time = date
    proxy.fields.date_time = date
    proxy.validationEnabled = true
    proxy.$v.$touch()
  }
}

const moveHints = (container) => {
  // move hints after labels
  const hints = container.find('i.wtchelpinfo')
  hints.each((index, hint) => {
    const $hint = $(hint)
    const parent = $hint.closest('tr').find('td:first-child')
    // parent.text(_.trim(parent.text()))
    parent.append($hint)
  })
}

const parseFields = (container, vm, options) => {
  const requiredFields = window.zsWebFormMandatoryFields
  // const labels = window.zsFieldsDisplayLabelArray
  const domFields = container.find('input, select, textarea')
  return _.keyBy(_.filter(_.map(domFields, f => {
    const el = $(f)
    const parent = el.closest('tr')
    const fieldParent = el.closest('td')
    const type = el.prop('type') || f.tagName.toLowerCase()
    const isButton = ['submit', 'button', 'reset'].includes(type)
    const isHidden = ['hidden'].includes(type)
    if (isButton) {
      parent.addClass('buttons-container')
    } else {
      if (!isHidden) {
        let labelContainer = parent.find('td:first-child')
        const label = _.trim(labelContainer.text())
        if (!labelContainer.find('label').length) {
          labelContainer.html(`<label>${label}</label>`)
        }
        labelContainer = labelContainer.find('label')

        const inputName = el.attr('name')
        const kebabName = _.kebabCase(inputName)
        const name = _.snakeCase(inputName)
        el.addClass(kebabName)
        parent.addClass(`form-field field-${kebabName}`)
        const rules = {}
        const messages = {}
        if (requiredFields.includes(inputName)) {
          labelContainer.addClass('required')
          rules.required = V.required
          messages.required = {error: `${label} is required.`}
        }
        if (name.includes('email')) {
          rules.email = V.email
          messages.email = {error: `The email must be a valid email address.`}
        }

        const isDate = ['input', 'date', 'text'].includes(type) && name.includes('date')
        if (isDate) {
          rules.date = (value) => {
            if (!_.isNil(value) && value !== '') {
              const date = DateTime.fromFormat(value, 'MM/dd/yyyy')
              if (!date.isValid) {
                return false
              }
              return date
            }
            return true
          }
          messages.date = {error: `The date is not valid.`}

          rules.dateMin = (value) => {
            const date = rules.date(value)
            if (!_.isBoolean(date)) {
              const min = DateTime.fromISO('2023-01-01')
              return date > min
            }
            return true
          }
          messages.dateMin = {error: `The date is too early.`}

          rules.dateMax = (value) => {
            const date = rules.date(value)
            if (!_.isBoolean(date)) {
              const max = DateTime.local().plus({days: 1}).startOf('day')
              return date < max
            }
            return true
          }
          messages.dateMax = {error: `The date can not be in future.`}
        }

        const error = fieldParent.find('.error')
        if (!error.length) {
          $(`<div class="error error-${kebabName} hidden"></div>`).appendTo(fieldParent)
        }

        // hide fields
        if (options.hideFields.includes(name)) {
          parent.hide()
        }

        const value = el.val()

        return {
          el,
          inputName,
          kebabName,
          name,
          rules,
          messages,
          value,
          type
        }
      }
    }
  })), 'name')
}

const overrideReset = (container, vm, proxy) => {
  const resetter = window.zsResetWebForm
  window.zsResetWebForm = function (webFormId) {
    resetter(webFormId)
    hydrate(container, vm, proxy)
  }
}

const overrideValidation = (container, vm, proxy) => {
  // const validator = window.zsValidateMandatoryFields
  window.zsValidateMandatoryFields = function () {
    proxy.$v.$touch()
    if (proxy.$v.$invalid) {
      return false
    } else {
      const submitButton = container.find('input[type=submit]')
      submitButton.prop('disabled', true)
    }
  }
}

